import Image from "components/common/images/Image";
import { CategoryModel } from "models";
import React from "react";
import { Slide } from "react-slideshow-image";
import CustomArrowSlide from "components/common/CustomArrowSlide";
import "react-slideshow-image/dist/styles.css";

type PROPS = {
  value?: string;
  data: CategoryModel[];
  onChange: (categoryId: string) => void;
};

const CorpListMainCategory: React.FC<PROPS> = (props) => {
  const [value, setValue] = React.useState("");
  const [n, setN] = React.useState(1);
  const [defaultIndex, setDefaultIndex] = React.useState(-1);

  const categoryList = React.useMemo(() => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_, ...data] = props.data;
    return {
      default: _ as CategoryModel,
      list: data as CategoryModel[],
    };
  }, [props.data]);

  React.useEffect(() => {
    if (!props.value) {
      setValue("");
    } else {
      setValue(props.value);
    }
    const n = Math.min(10, categoryList.list.length);
    setN(n);

    const idx = categoryList.list.findIndex((v) => v.id === props.value);
    console.log(idx);
    if (idx >= 0) {
      setDefaultIndex(Math.min(idx, categoryList.list.length - n));
    } else {
      setDefaultIndex(0);
    }
  }, [categoryList.list, props.value]);

  if (defaultIndex < 0) {
    return <></>;
  }

  return (
    <div className="flex">
      <div
        style={{
          width: `calc(1920px / ${n})`,
        }}
        className="flex justify-center h-full"
      >
        <button
          className="m-2 p-2 hover:bg-gray-200 rounded disabled:pointer-events-none max-w-max disabled:text-jhk-blue flex flex-col items-center justify-center"
          style={{
            minWidth: '90%',
            boxShadow: categoryList.default.id == value ? 'rgba(0, 0, 0, 0.25) 0px 3px 8px' : 'rgba(0, 0, 0, 0.1) 0px 3px 8px'
          }}
          onClick={() => {
            props.onChange(categoryList.default.id);
          }}
          disabled={categoryList.default.id == value}
        >
          <div className="flex justify-center">
            <span className="text-xs">{categoryList.default.name}</span>
          </div>
        </button>
      </div>

      <div
        style={{
          width: `calc(100% - (calc(100% / ${n - 1})))`,
        }}
        className="ml-auto flex-1"
      >
        <Slide
          defaultIndex={defaultIndex}
          slidesToShow={n}
          slidesToScroll={n}
          transitionDuration={300}
          autoplay={false}
          infinite={false}
          arrows={props.data.length > 10}
          {...CustomArrowSlide()}
        >
          {categoryList.list.map((cat, index) => (
            <div key={index} className="flex justify-center h-full">
              <button
                key={index}
                className="m-2 p-2 hover:bg-gray-200 rounded disabled:pointer-events-none max-w-max disabled:text-jhk-blue flex flex-col items-center justify-center"
                style={{
                  minWidth: '90%',
                  boxShadow: cat.id == value ? 'rgba(0, 0, 0, 0.25) 0px 3px 8px' : 'rgba(0, 0, 0, 0.1) 0px 3px 8px'
                }}
                onClick={() => {
                  props.onChange(cat.id);
                }}
                disabled={cat.id == value}
              >
                <div className="flex justify-center">
                  <span className="text-xs break-all">{cat.name}</span>
                </div>
              </button>
            </div>
          ))}
        </Slide>
      </div>
    </div>
  );
};

export default CorpListMainCategory;
